import { useFeatureFlags } from 'frontend/js/modules/infra/feature-flags/hooks';
import { isBarberSessionView, useSession } from '../../../infra/session';
export var useShowReportingBotButton = function () {
    var isReportingBotEnabled = useFeatureFlags().reportingBot;
    var session = useSession().data;
    return isBarberSessionView(session === null || session === void 0 ? void 0 : session.view) && isReportingBotEnabled;
};
